/**
 * Shape Style Utilities
 * Standardized shape tokens for consistent rounded elements
 * 
 * Note: The Badge component has rounded-full built-in.
 * Use pillShape for custom non-Badge elements only.
 */

// Pill-shaped elements (custom elements, buttons, toggle elements)
export const pillShape = 'rounded-full';

// Standardized pill badge height (for text badges, not icon buttons)
export const pillBadgeHeight = 'h-5'; // 20px

// True circular elements (avatars, orbs, icon containers)
export const circleShape = 'rounded-full';

// Moderate rounding for cards and panels
export const cardShape = 'rounded-2xl';

// Subtle rounding for containers and boxes
export const boxShape = 'rounded-lg';
